import React, { useState } from 'react';
import EukaDataTable from "euka-datatables";
import ShowNav from '../Auth/ShowNav';
import { Modal, Button } from 'antd';
    let columns = [
    {
        name:'time',
        label:'Time'
    },
    {
        name:'date',
        label:'Date'
        },
    ]

    let options = {
    responsive:'collapse'
};
const Time = () => {
    const [groups, setGroups] = useState([{ time: '12:00', date: '2021-08-06' }])
     const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
    return (<div className="container">
        <ShowNav />
        <h4 style={{ color: 'white' }}>Time</h4>
        <div className="row">
            <div className="col-sm-12 float-end">
                <Button type="primary" onClick={showModal}>
        Add Time
      </Button>
            </div>
             </div>
        <Modal title="Add New Group" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}
                      footer={[
            <Button key="Close" onClick={handleCancel}>
              Close
            </Button>,
            <Button key="Add Group" type="primary"  onClick={handleOk}>
              Add Time
            </Button>,
           
          ]}
        
        >
            <p>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>
                                Time
                            </label>
                            <input type="time" className="form-control" />
                        </div>
                    </div>
                </div>
        </p>
        
      </Modal>
                <EukaDataTable
    key={'table-1'}
    title={'Time'}
    columns={columns}
    data={groups}
    options={options}
/>
    </div>);
}
 
export default Time;